module.exports = __webpack_public_path__ + "img/logo.feff5ef6.svg";